import type { PlayerItemVisitResponseRelatedVisitDateRelatedPagedData } from '@on3/api';
import { useToggle } from '@on3/ui-lib';
import clsx from 'clsx';
import type { SetStateAction } from 'react';

import { PlayerCard } from './PlayerCard';
import styles from './VisitList.module.scss';
import { VisitListColumnHeaders } from './VisitListColumnHeaders';
import { VisitListItem } from './VisitListItem';

export interface IVisitListProps
  extends PlayerItemVisitResponseRelatedVisitDateRelatedPagedData {
  hide?: boolean;
  setHide?: (value: SetStateAction<boolean>) => void;
}

export const VisitList = ({
  list,
  pagination,
  relatedModel,
}: IVisitListProps) => {
  const { status } = relatedModel || {};
  const [hide, setHide] = useToggle(status === 'Future');
  const isCurrent = status === 'Current';

  return (
    <>
      <VisitListColumnHeaders
        hide={hide}
        list={list}
        pagination={pagination}
        relatedModel={relatedModel}
        setHide={setHide}
      />
      <ul
        className={clsx(styles.visitListContainer, {
          [styles.hideList]: hide,
          [styles.nextUpContainer]: isCurrent,
        })}
      >
        {list?.map((player, index) => {
          // Every player will have a key
          if (!player?.psoKey) {
            return null;
          }

          return (
            <li
              className={clsx({
                [styles.playerCardWrapper]: isCurrent,
              })}
              key={`${player?.psoKey - index}`}
            >
              {isCurrent && (
                <PlayerCard {...player} /> //Display for Next Up: Visits
              )}
              {!isCurrent && (
                <VisitListItem {...player} /> //Display for future/past visits
              )}
            </li>
          );
        })}
      </ul>
      {/*TODO: Uncomment when Visit Center is built */}
      {/* <TextLink
        //TODO: Add href for this once endpoint is done
        className={clsx(styles.visitCenterLink, { [styles.hide]: hide })}
        color="primary"
        variant="subtitle1"
      >
        Visit Center
      </TextLink> */}
    </>
  );
};
